import React, { useContext, useEffect } from "react";
import styled from "styled-components";

import useState from "Hooks/useState";
import PinCode from "Components/PinCodeOTP/PinCode";
import Axios from "axios";
import language from "Utils/language";
import globalContext from "Hooks/globalContext";
import { HOST } from "Utils/constants";

const PageVIew = styled.div`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const Container = ({ history }) => {
  const phase = useState(0);
  const error = useState(null);
  const { httpHeader, modal, language: lang } = useContext(globalContext);

  const oldPin = useState("");
  const isLoading = useState(false);

  const getAuth = async () => {
    const { data } = await Axios.post(`${HOST}/user/otp/validation`, { pin: oldPin.state }, httpHeader());
    oldPin.setState("");

    if (data.status) {
      error.setState("");
      const { data } = await Axios.post(`${HOST}/user/otp/reset`, {}, httpHeader());
      modal.setState(language("OTP가 초기화되었습니다. 재등록해주세요.", lang.state));
      history.goBack();
    } else {
      isLoading.setState(false);
      switch (data.code) {
        case "blocked":
          error.setState(language("잠금상태입니다. 잠시 후에 다시 시도해주세요.", lang.state));
          break;
        case "block":
          error.setState(language("비밀번호 3회 오류로 5분간 송금이 제한됩니다.", lang.state));
          break;
        case "invalid":
          error.setState(language("잘못된 OTP 인증번호입니다.", lang.state));
          break;
        case "server":
          error.setState(language("서버 오류입니다. 잠시 후에 다시 시도해주세요.", lang.state));
          break;
      }
    }
  };

  useEffect(() => {
    if (oldPin.state.length > 5 && !isLoading.state) {
      isLoading.setState(true);
      getAuth();
    }
  }, [oldPin.state]);

  return (
    <PageVIew>
      <PinCode
        isLoading={isLoading.state}
        pin={oldPin}
        title={language("등록한 OTP의 6자리 번호를 입력해주세요.", lang.state)}
        error={error.state}
      />
    </PageVIew>
  );
};

export default Container;
